import { useMemo } from 'react';
import { aggregateByUnit } from '../lib/aggregate.js';
import { formatNumber } from '../lib/format.js';

function percent(share) {
  return `${Math.round(share * 1000) / 10}%`;
}

// One tile per unit. Units are deliberately not placed on a shared axis because a BRL
// total and a USD total are different quantities; each tile is its own hero number.
export function DenominationSummary({ supplies, onSelect }) {
  const buckets = useMemo(() => aggregateByUnit(supplies), [supplies]);
  if (!buckets.length) return null;

  return (
    <div className="denomination-summary" aria-label="Observed obligations by unit">
      <div className="denomination-intro">
        <span className="eyebrow">Denominated obligations</span>
        <p>Token units summed per unit at issuer par. No exchange rates are applied and units are never combined.</p>
      </div>
      <div className="denomination-tiles">
        {buckets.map((bucket) => (
          <div className="denomination-tile" key={bucket.unit}>
            <div className="denomination-head">
              <span>{bucket.unit}</span>
              <small>{bucket.instrumentCount} instrument{bucket.instrumentCount === 1 ? '' : 's'}</small>
            </div>
            <strong>{formatNumber(bucket.total, { compact: true })}</strong>
            <div className="denomination-bar" role="img" aria-label={`${bucket.leader.ticker} holds ${percent(bucket.segments[0].share)} of observed ${bucket.unit} obligations`}>
              {bucket.segments.map((segment, index) => (
                <button
                  type="button"
                  key={segment.key}
                  className={`denomination-segment ${index === 0 ? 'lead' : ''} ${segment.other ? 'other' : ''}`}
                  style={{ flexGrow: Math.max(segment.share, 0.008) }}
                  title={`${segment.ticker}${segment.programName ? ` (${segment.programName})` : ''}: ${formatNumber(segment.value)} ${bucket.unit}, ${percent(segment.share)}`}
                  aria-label={`${segment.ticker}: ${formatNumber(segment.value)} ${bucket.unit}, ${percent(segment.share)}`}
                  disabled={segment.other}
                  onClick={() => !segment.other && onSelect?.(segment.programId)}
                />
              ))}
            </div>
            <small className="denomination-lead">{bucket.leader.ticker} {percent(bucket.segments[0].share)}</small>
          </div>
        ))}
      </div>
    </div>
  );
}
